import React, { useEffect, useState } from "react";
import logo from "../../assets/image/logo/eye.png";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Loaders } from "../../pages/Loaders";
import { login, LoginOtp } from "../apifile/ApiFiles";
import { cloudinaryBaseUrl } from "./baseUrl";
import OtpModal from "./otpModal/OtpModal";
import ResetPasswod from "./resetPasswod/ResetPasswod";
import ResetPasswodTokenModel from "./resetPasswodTokenModel/ResetPasswodTokenModel";
function Login({ loginPageData }) {
  const [modalShow, setModalShow] = useState(false);
  const [modalShowReset, setModalShowReset] = useState(false);
  const [modalShowResetToken, setModalShowResetToken] = useState(false);
  const [user, setUser] = useState()
  const params = useParams()


  const [loader, setLoader] = useState(false)
  const [initialVal, setInitialVal] = useState({
    email: "",
    password: "",
    lat: '',
    long: '',
    ipaddress: '',
    browser: '',
    device: ''
  });
  const [loginUser, setLoginUser] = useState(false)

  const changeHandler = (e) => {
    const clone = { ...initialVal };
    const value = e.target.value;

    const name = e.target.name;
    clone[name] = value;
    setInitialVal(clone);
  };

  const navigate = useNavigate();

  const notify = (updateMassage) => toast(updateMassage);

  const [idSave, setIpSave] = useState('')

  const getData = async () => {
    // const res = await axios.get("https://api.ipify.org/?format=json");


    // const deviceDetector = new DeviceDetector();
    // const userAgent = "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/69.0.3497.81 Safari/537.36";
    // const device = deviceDetector.parse(userAgent);

    // console.log(deviceDetector);
    // setIpSave(res.data)

    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const randomString = Math.random().toString(20).substring(2, 14) + Math.random().toString(20).substring(2, 14);

    const deviceID = `${userAgent}-${platform}-${randomString}`;
    console.log(deviceID)

  };

  useEffect(() => {
    getData()
  }, [])

  useEffect(() => {
    // 1. Get location (lat, long)
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setInitialVal((prev) => ({
            ...prev,
            lat: position.coords.latitude,
            long: position.coords.longitude
          }));
        },
        (error) => {
          console.error("Geolocation Error:", error.message);
        }
      );
    }

    // 2. Get IP Address
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => {
        setInitialVal((prev) => ({
          ...prev,
          ipaddress: data.ip
        }));
      })
      .catch((err) => console.error("IP Fetch Error:", err));

    // 3. Get Browser
    const userAgent = navigator.userAgent;
    let browser = "Unknown";

    if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
      browser = "Chrome";
    } else if (userAgent.includes("Firefox")) {
      browser = "Firefox";
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      browser = "Safari";
    } else if (userAgent.includes("Edg")) {
      browser = "Edge";
    }

    // 4. Get Device Type
    const isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent);
    const device = isMobile ? "Mobile" : "Desktop";

    setInitialVal((prev) => ({
      ...prev,
      browser,
      device
    }));
  }, []);



  const handleSubmit = async () => {
    // console.log('initialVal', initialVal);
    setLoader(true)
    // window.localStorage.setItem('token', 'token')
    try {
      const res = await login(initialVal)
      // console.log(res);
      if (res?.data?.statusCode == 201) {
        setUser(res?.data?.data?.user)
        notify('OTP Sent Successfully, Valid for 10 min only');
        setModalShow(true)
      } else if (res?.data?.statusCode == 200) {
        notify("Login Successful");
        window.localStorage.setItem('token', res.data?.data?.user)
        window.localStorage.setItem('role', res?.data?.data?.user)
        setTimeout(() => {
          navigate("/admin");
        }, 1000);
        window.location.reload()
      } else {
        alert(res?.data.message)
        setLoader(false)
        return
      }
      // window.localStorage.setItem('token', res.data?.token)
      // window.localStorage.setItem('role', res.data?.token)
      // setTimeout(() => {
      //   navigate("/admin");
      // }, 1000);
    } catch (error) {
      alert(`Wrong Password or Email Detect ${error?.message}`);
    }
    setLoader(false)
  };

  const handleVerifyOtpget = async (otp) => {
    // console.log('Verified OTP:', otp);
    // setLoader(true)
    const clone = { ...initialVal, otp: otp, user_id: user }
    try {
      const res = await LoginOtp(clone)
      if (res?.data?.statusCode == 200) {
        notify("Login Successful");
        window.localStorage.setItem('token', res.data?.data?.user)
        window.localStorage.setItem('role', res?.data?.data?.user)
        setModalShow(false)
        setTimeout(() => {
          navigate("/admin");
          window.location.reload();
        }, 1000);
        // setModalShow(false)
      } else {
        alert(res?.data?.message)
        // setLoader(false)
        return
      }

    } catch (error) {
      setLoader(false)
    }
  };

  const handleSubmitUser = async () => {
    window.localStorage.setItem('token', 'token')
    // navigate("/admin");
    // return
    try {
      const res = await login(initialVal)
      if (res.statusCode == 200) {
        notify("Login Successfull");
      } else {
        alert(res.message)
        setLoader(false)
        return
      }
      window.localStorage.setItem('token', res.token)
      setTimeout(() => {
        navigate("/admin");
      }, 1000);
    } catch (error) {
      alert("Wrong Password or Email Detect");
    }


  };

  const defaultLogo = "https://www.abarissoftech.com/assets/img/logo-2.png";

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate("/admin");
    }
  }, []);

  const resetModalOpen = () => {
    setModalShowReset(true)
  }

  useEffect(() => {
    if (params?.token) {
      setModalShowResetToken(true);
    }
  }, [params?.token]);

  return (
    <>
      <section className="login_main_sec">
        {loader && <Loaders />}

        <div className="container">

          <div className="login_card">
            <div className="login_logo_container">
              <img
                src={
                  loginPageData?.data?.logo
                    ? `${cloudinaryBaseUrl}${loginPageData.data.logo}`
                    : ''
                }
                alt="Logo"
                className="img-fluid w-50"
              />
            </div>

            <div className="login_form_container">
              <div className="header-area">
                <h4 className="lgo" style={{ color: 'rgb(8 61 138)', fontWeight: '700' }}>Login to your account.</h4>
              </div>
              <form>
                <div className="mb-4">
                  <input
                    type="email"
                    className="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Email"
                    name="email"
                    value={initialVal.email}
                    onChange={changeHandler}
                  />
                </div>
                <div className="mb-4">
                  <input
                    type="password"
                    className="form-control"
                    id="exampleInputPassword1"
                    placeholder="Password"
                    name="password"
                    value={initialVal.password}
                    onChange={changeHandler}
                  />
                </div>

                <div className="forgot mb-4">
                  <div className=" form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="exampleCheck1"
                    />
                    <label className="form-check-label" htmlFor="exampleCheck1" style={{ color: 'rgb(8 61 138)' }}>
                      Remember me
                    </label>
                  </div>
                  {/* <div className=" form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="exampleCheck2"
                    checked={loginUser}
                    onChange={() => { setLoginUser(!loginUser) }}
                  />
                  <label className="form-check-label" htmlFor="exampleCheck2">
                    Login As User
                  </label>
                </div> */}
                  <div>
                    <a href="#" style={{ color: "rgb(8 61 138)" }} onClick={resetModalOpen}>forgot Password</a>
                  </div>
                </div>
                {/* <button
                type="button"
                className="btn btn-primary btn_login"
                onClick={loginUser ? handleSubmitUser : handleSubmit}
              >
                {loginUser ? 'LOGIN USER' : 'LOGIN ADMIN'}
              </button> */}
                <button
                  type="button"
                  className="btn btn-primary btn_login"
                  onClick={handleSubmit}
                  disabled={!initialVal?.email || !initialVal?.password}
                >
                  {loginPageData?.data?.login_via_otp ? 'Login' : 'Login'}


                </button>
              </form>
            </div>
          </div>
        </div>
      </section >

      <OtpModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        handleVerifyOtpget={handleVerifyOtpget}
      />

      <ResetPasswod
        show={modalShowReset}
        onHide={() => setModalShowReset(false)}
      />
      <ResetPasswodTokenModel
        show={modalShowResetToken}
        onHide={() => setModalShowResetToken(false)}
        params={params}
      />

      <ToastContainer />
    </>
  );
}

export default Login;
